<template>
  <tr>
    <td>{{ userData.name }}</td>
    <td>{{ userData.email }}</td>

    <td>
      <!-- Admin case: show both boxes -->
      <template v-if="userData.isAdmin">
        <div class="gray-box mb-2">人事</div>
        <div class="gray-box">アカウント追加・削除可</div>
      </template>

      <template v-else-if="userData.isCreateReviewUser">
        <div class="gray-box">人事</div>
      </template>

      <template v-else>
        <div class="gray-box">部門</div>
      </template>
    </td>
    <td class="dlt-block">
      <button class="btn-plain btn-heart template-Btn" @click="editUser()">
        <img
          :src="require('@/assets/images/pencil.svg')"
          alt="編集"
          class="icon-label"
        />
      </button>
      <button
        class="btn-plain btn-heart template-Btn ms-2"
        @click="openDeletePopup()"
        v-b-modal="userData.id"
      >
        <img
          :src="require('@/assets/images/dustbin.svg')"
          alt="削除"
          class="icon-label"
        />
      </button>
    </td>
    <ConfirmationModal
      ref="confirmationModal"
      :message="'このアカウントを削除しますか？'"
      @cancel="closeDeleteModal"
      @confirm="destroy"
    />
    <!-- <b-modal
      :id="userData.id"
      ok-variant="outline-danger mw-auto"
      cancel-variant="outline-primary mw-auto"
      button-size="sm"
      cancel-title="キャンセル"
      ok-title="OK"
      @ok="destroy"
      hide-header
    >
      <div class="text-center p-4">
        <div class="dlt-block">
          <i class="fa fa-trash" aria-hidden="true"></i>
          <p>ユーザーを削除しますか</p>
        </div>
      </div>
    </b-modal> -->
    <CreateUser
      v-if="showCreateUserPopup"
      :isEditing="true"
      :user="userData"
      @hideModal="hideModal"
    />
  </tr>
</template>

<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations } from 'vuex';
import CreateUser from './CreateUser.vue';
import ConfirmationModal from '@/components/utils/ConfirmationModal.vue';

export default {
  name: 'UserRow',
  props: ['userData', 'contactAuthority'],
  components: { CreateUser, ConfirmationModal },
  data() {
    return {
      // user: this.userData,
      modal: false,
      showCreateUserPopup: false,
      showDeleteConfirmationPopup: false,
    };
  },
  computed: {
    admin() {
      return this.userData.isAdmin || this.userData.isCreateReviewUser
        ? '人事'
        : '部門';
    },
    reviewer() {
      return this.userData.isAdmin
        ? 'アカウント追加・削除可'
        : this.userData.isCreateReviewUser
        ? '無し'
        : '-';
    },
    notification() {
      return this.userData.notification ? 'On' : 'Off';
    },
    individualContact() {
      return this.userData.userContactAuthority ? '有り' : '無し';
    },
  },
  methods: {
    ...mapMutations({
      unsetUser: 'unsetUser',
    }),
    openDeletePopup() {
      this.$refs.confirmationModal.show();
    },
    closeDeleteModal() {
      this.$refs.confirmationModal.hide();
    },
    editUser() {
      this.showCreateUserPopup = true;
    },
    hideModal() {
      this.showCreateUserPopup = false;
    },
    destroy() {
      this.loading = true;
      ApiService.delete(Api.endpoints.DELETEUSER(this.userData.id)) // eslint-disable-next-line
        .then(() => {
          this.unsetUser(this.userData);
          this.closeDeleteModal();
          this.loading = false;
        })
        .catch((error) => {
          this.parseErrorResponse(error.response);
        });
    },
  },
};
</script>

<style scoped>
td {
  height: 50px;
  font-weight: normal;
  text-align: left;
}

.dlt-block {
  text-align: center !important;
}

.dlt-block i {
  font-size: 30px;
  color: red;
  margin-bottom: 10px;
}
.gray-box {
  width: 194px;
  margin: auto;
  height: 25px;
  background-color: #787878;
  color: #fff;
  border-color: #787878;
  padding: 4px;
  border-radius: 4px;
  font-weight: 400;
  text-align: center !important;
}
</style>
